import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { useShopCart } from '@/hooks/useShop';
import ShopMiniCart from './ShopMiniCart';
import { useShopEnabled } from '@/hooks/usePlatformSettings';

const HIDDEN_PATHS = ['/boutique/panier', '/boutique/commande'];

function isProductPage(pathname: string) {
  return pathname.startsWith('/boutique/') && !pathname.endsWith('/panier') && !pathname.endsWith('/commande') && pathname !== '/boutique';
}

export default function ShopFloatingCart() {
  const [open, setOpen] = useState(false);
  const { data: cart } = useShopCart();
  const location = useLocation();
  const { shopEnabled } = useShopEnabled();

  const itemCount = cart?.items?.reduce((sum, i) => sum + i.quantity, 0) || 0;
  const hidden = !shopEnabled || itemCount === 0 || HIDDEN_PATHS.some(p => location.pathname.startsWith(p)) || isProductPage(location.pathname);

  if (hidden) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-glow hover:scale-110 transition-transform duration-200 animate-scale-in"
        aria-label={`Panier (${itemCount} articles)`}
      >
        <ShoppingBag className="h-6 w-6" />
        <span className="absolute -top-1 -right-1 flex items-center justify-center h-5 min-w-5 px-1 rounded-full bg-destructive text-destructive-foreground text-xs font-bold">
          {itemCount}
        </span>
      </button>
      <ShopMiniCart open={open} onOpenChange={setOpen} />
    </>
  );
}